var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"acb"},[_c('div',{staticClass:"btn-action",class:{active: _vm.active},domProps:{"innerHTML":_vm._s(_vm.label)},on:{"click":function($event){return _vm.$emit('input', _vm.name)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }